import { Toast } from "@sscs/ui";
import { Member } from "Types";
import { apiErrorToast } from "Utils";
import { useResendInviteUserMutation } from "../../services/invite.api";

const useResendInvite = (member: Member, onResponse: () => void) => {
  const [resendInviteUser] = useResendInviteUserMutation();

  const handleResend = async () => {
    try {
      await resendInviteUser({
        userId: member.user_id,
      }).unwrap();
    } catch (error) {
      apiErrorToast(error, "Could not resend invite to member!");
      return;
    } finally {
      onResponse();
    }

    Toast.show({
      title: "Member invite resent",
      type: "success",
    });
  };

  return {
    handleResend,
  };
};

export default useResendInvite;
